import Resource from '@/api/resources/Resource'

class IncidentsTypesConfigurationOriginsRelationshipServices extends Resource {
    async getIncidentTypeOriginsRelationship(id) {
        const response = await this.axios.get(`/configuration/incidentTypes/${id}/incidentTypeOrigins`)
        return response.data
    }

    async createIncidentTypeOriginsRelationship(request) {
        const response = await this.axios.post(`/configuration/incidentTypeOrigins`, request)
        return response.data
    }

    async deleteIncidentTypeOriginsRelationship(idOriginRelationship) {
        const response = await this.axios.delete(`/configuration/incidentTypeOrigins/${idOriginRelationship}`)
        return response.data
    }
}

export default new IncidentsTypesConfigurationOriginsRelationshipServices()
